import {
  AccessTime,
  AccountBalance,
  ArrowBack,
  Article,
  Assignment,
  AttachMoney,
  AutoGraph,
  BarChart,
  Business,
  Calculate,
  Commute,
  Construction,
  ContentCopy,
  DashboardSharp,
  Delete,
  DirectionsCar,
  DirectionsCarFilled,
  DirectionsCarFilledTwoTone,
  DisplaySettings,
  Edit,
  EmojiTransportation,
  Engineering,
  Factory,
  FamilyRestroom,
  FileCopy,
  FlashlightOff,
  GetApp,
  GridOnOutlined,
  Groups,
  HealthAndSafety,
  LocalAtm,
  LocalHospital,
  MoveDown,
  NewReleases,
  Paid,
  PendingActions,
  Percent,
  PhotoCamera,
  PointOfSale,
  Print,
  Receipt,
  Refresh,
  Roofing,
  Settings,
  SettingsApplications,
  Share,
  ShoppingCart,
  SimCardDownload,
  Snowmobile,
  SouthAmerica,
  TextSnippet,
  Today,
  Visibility,
  Warning,
  Check,
  Inventory,
  StorefrontOutlined,
  Person,
  MenuBook,
  Public,
  Update,
  ViewComfy,
  AddShoppingCart,
  QueryStats,
  HomeRepairService,
  SettingsSuggest,
  AltRoute,
  LocalShipping,
  FactCheck,
  DesignServices,
  Bento,
  MonetizationOn,
  FormatPaint,
  BackupTable,
  History,
  AddBusiness,
  Adjust,
  Balance,
  Cancel,
  Warehouse,
  AccountTree,
  ViewModule,
  Home,
  Discount,
  Build,
  QuestionAnswer,
  List,
  Link,
  Favorite,
  Signpost,
  InstallDesktop,
  AdUnits,
  CarRepair,
  Pin,
  Difference,
  ContactSupport,
} from '@mui/icons-material';

export const ApplicationIcons = {
  AccessTime: AccessTime,
  ActionBulletins: FileCopy,
  ActionDelete: Delete,
  ActionDuplicate: ContentCopy,
  ActionEdit: Edit,
  ActionGenerateReport: GetApp,
  ActionPrint: Print,
  ActionRefresh: Refresh,
  ActionCancel: Cancel,
  ActionView: Visibility,
  ActionToggleListView: List,
  ActionToggleCardView: ViewModule,
  Approve: Check,
  Article: Article,
  Association: Share,
  AuthorizedPeople: FamilyRestroom,
  Back: ArrowBack,
  Calculate: Calculate,
  Ceiling: Roofing,
  Communications: NewReleases,
  Consent: PhotoCamera,
  Creditor: AccountBalance,
  Dealer: Snowmobile,
  DownloadableDocument: SimCardDownload,
  EmergencyContacts: Warning,
  Employee: Engineering,
  Employees: Engineering,
  Establishment: Business,
  Expenses: LocalAtm,
  FlashlightOff: FlashlightOff,
  GlobalConfigurations: DisplaySettings,
  Group: Groups,
  Groups: Groups,
  InventoryItem: Inventory,
  Inventory: BackupTable,
  Invoice: Receipt,
  InvoiceItem: ShoppingCart,
  InvoiceItems: ShoppingCart,
  InvoiceSettings: SettingsApplications,
  Invoices: Receipt,
  Logs: MenuBook,
  LoiRelatedPackage: AttachMoney,
  MarketGuide: AutoGraph,
  Medical: LocalHospital,
  Origin: Public,
  PanelHeader: StorefrontOutlined,
  PanelType: GridOnOutlined,
  Payment: AttachMoney,
  Payments: AttachMoney,
  Project: Assignment,
  Vendor: Factory,
  Rate: Percent,
  Region: SouthAmerica,
  Renewal: PendingActions,
  Renewals: PendingActions,
  Report: TextSnippet,
  Reports: BarChart,
  Sale: PointOfSale,
  SalesTax: Paid,
  Settings: Settings,
  Tooling: Construction,
  Transactions: MoveDown,
  Trimesters: DashboardSharp,
  Update: Update,
  Users: Person,
  Vehicle: DirectionsCarFilledTwoTone,
  VehicleClass: DirectionsCarFilled,
  VehicleCondition: HealthAndSafety,
  VehicleFile: Commute,
  VehicleMake: EmojiTransportation,
  VehicleModel: DirectionsCar,
  VehicleYear: Today,
  View: Visibility,
  Walls: ViewComfy,
  AdditionalItems: AddShoppingCart,
  DealerInventory: Inventory,
  Summary: QueryStats,
  AdditionalService: HomeRepairService,
  Customization: SettingsSuggest,
  OtherService: AltRoute,
  Transport: LocalShipping,
  AddressCheck: FactCheck,
  Design: DesignServices,
  ShadowBox: Bento,
  ProjectCost: Factory,
  ProjectTotal: AttachMoney,
  ProjectProfit: MonetizationOn,
  Graphics: FormatPaint,
  GraphicPrintOnDemand: Print,
  Histories: History,
  CycleCount: Balance,
  CycleCountAdjustment: AddBusiness,
  Adjustment: Adjust,
  PurchaseOrder: ShoppingCart,
  PurchaseOrderReception: Warehouse,
  Prepaids: Factory,
  ProjectNumber: AccountTree,
  Home: Home,
  Promotion: Discount,
  SpareParts: Build,
  FAQ: QuestionAnswer,
  UsefullLink: Link,
  Favorite: Favorite,
  Cart: ShoppingCart,
  SignHolder: Signpost,
  FloorDisplay: InstallDesktop,
  SpecializedDisplay: DisplaySettings,
  Furniture: AdUnits,
  PartsServices: Settings,
  VehiclePurpose: CarRepair,
  ExteriorSignage: Pin,
  MerchandisingProgram: Difference,
  UsefulLink: Link,
  Support: ContactSupport,
};
